import { useEffect } from 'react'
import { Box, Pagination } from '@mui/material'
import PartnersList from './PartnersList'
import Select from '@/components/Select'
import TextField from '@/components/TextField'
import useAdmin, { PartnerType } from '../hooks/useAdmin'

const styles = {
  container: {
    paddingTop: '20px',
    display: 'grid',
    gridTemplateColumns: '1fr 6fr',
    gap: '20px'
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  pagination: {
    mt: '25px',
    alignSelf: 'center'
  }
}

export const TEXT_ON_CHANGE_DELAY = 600

export const Admin = () => {
  const {
    partners,
    totalPages,
    partnerType,
    pagination,
    filter,
    sort,
    setPage,
    setPartnerType,
    setFilters,
    fetchPartners,
    selectPartner
  } = useAdmin()

  useEffect(() => {
    fetchPartners()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, sort, pagination, partnerType])

  return (
    <Box sx={styles.container}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <Select
          fullWidth
          testId="partner-type-select"
          label="Partner Type"
          value={partnerType}
          options={['affiliates', 'publishers', 'vendors']}
          optionLabels={['Affiliates', 'Publishers', 'Vendors']}
          onChange={(option) => setPartnerType(option as PartnerType)}
        />

        <TextField
          fullWidth
          testId="name-text-field"
          label="Name"
          onChangeDelay={TEXT_ON_CHANGE_DELAY}
          onChange={(value) => setFilters('q', value)}
        />

        <TextField
          fullWidth
          testId="id-text-field"
          label="ID"
          type="number"
          onChangeDelay={TEXT_ON_CHANGE_DELAY}
          onChange={(value) => setFilters('id', value)}
        />
      </Box>
      <Box sx={styles.listContainer}>
        <PartnersList
          partners={partners}
          showCompanyName={partnerType !== 'publishers'}
          onClick={selectPartner}
        />
        <Pagination
          page={pagination.page}
          count={totalPages}
          sx={styles.pagination}
          onChange={(_, page) => setPage(page)}
        />
      </Box>
    </Box>
  )
}
